import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import styles from './header.module.scss';
import LogoIcon from '../../assets/icons/logo-short-inverted.svg';
import ToggleSwitchComponent from '../toggle/toggle.component';
import { ReactComponent as KebabIcon } from '../../assets/icons/kebab-icon.svg';
import { ReactComponent as RoundedQuestionIcon } from '../../assets/icons/round-question.svg';
import { ReactComponent as ShareIcon } from '../../assets/icons/share.svg';
import {
  CLICKED_START_RECORDING,
  CLOSE_CINTEL,
  CLOSE_ISSUE_POPUP,
  OPEN_CINTEL,
  OPEN_ISSUE_POPUP,
  SHOW_SNACKBAR,
  SHOW_STOP_REC_MODAL,
} from '../../store/action-types';
import { RootState } from '../../store/reducers';
import {
  startRecordingClickEvent,
  stopRecordingClickEvent,
} from '../../lib/ga/events';
import useDeviceDimension from '../../hooks/useDeviceDimension';

const Header: React.FC = () => {
  const {
    cintelPanelOpen,
    // isOwner,
    hideCintel,
    isMeetingRecorded,
    roomDetails,
    isLoggedIn,
    issuePopupOpen,
    orgName,
    participantPasscode,
  } = useSelector((state: RootState) => state.common);
  const [checked, setChecked] = useState(isMeetingRecorded);
  const dispatch = useDispatch();
  const isMobile = useDeviceDimension();

  const handleChange = () => {
    if (checked && isLoggedIn) {
      stopRecordingClickEvent();
      dispatch({ type: SHOW_STOP_REC_MODAL });
    } else {
      startRecordingClickEvent();
      dispatch({ type: CLICKED_START_RECORDING, payload: true });
    }
  };

  const handleToggleKebab = () => {
    if (cintelPanelOpen) {
      dispatch({ type: CLOSE_CINTEL });
    } else {
      dispatch({ type: CLOSE_ISSUE_POPUP });

      dispatch({ type: OPEN_CINTEL });
    }
  };

  const handleToggleIssuesButton = () => {
    if (issuePopupOpen) {
      dispatch({ type: CLOSE_ISSUE_POPUP });
    } else {
      if (!isMobile) {
        dispatch({ type: CLOSE_CINTEL });
      }

      dispatch({ type: OPEN_ISSUE_POPUP });
    }
  };

  const handleShareButtonClick = () => {
    try {
      const url = `${window.location.origin}${window.location.pathname.replace('/meet', '')}?org=${orgName}&passcode=${participantPasscode}`;
      navigator.clipboard.writeText(url);
      dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          type: 'success',
          message: 'Meeting link copied',
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setChecked(isMeetingRecorded);
  }, [isMeetingRecorded]);

  return (
    <nav className={styles['header-container']}>
      <div className={styles['logo']}>
        <img
          src={roomDetails?.organisation?.logo || LogoIcon}
          alt="header-logo"
          className="h-6 w-6 lg:h-9 lg:w-9 rounded-full"
          onError={(e) => {
            e.currentTarget.onerror = null; // prevents looping
            e.currentTarget.src = LogoIcon;
          }}
        />
        <div className="font-fjalla text-white text-xl leading-7 ml-3 hidden lg:block">
          {roomDetails?.organisation?.name || 'Zipteams'}
        </div>
      </div>

      <div className={styles['actions']}>
        {isLoggedIn &&
          roomDetails?.room_type === 'JITSI' &&
          roomDetails?.organisation?.is_recording_enabled && (
            <ToggleSwitchComponent checked={checked} onChange={handleChange} />
          )}
        {isLoggedIn && !hideCintel && (
          <Button
            variant="contained"
            className={`${styles['cintel-button']} ${
              cintelPanelOpen ? styles['clicked'] : ''
            }`}
            disableElevation
            disableRipple
            type="button"
            onClick={handleToggleKebab}
          >
            <KebabIcon
              className={`w-1 h-3 lg:h-4 fill-current ${
                cintelPanelOpen ? 'text-primary' : 'text-white'
              }`}
            />
          </Button>
        )}
        <button
          type="button"
          className="pl-3 flex items-center"
          onClick={handleToggleIssuesButton}
        >
          {!isLoggedIn && (
            <div className="flex text-white underline items-center px-2 text-xs lg:text-base">
              Having audio/camera issues
            </div>
          )}
          <RoundedQuestionIcon className="w-5 lg:w-7" />
        </button>

        <button
          type="button"
          className="pl-3 pr-4 flex items-center"
          onClick={handleShareButtonClick}
        >
          <ShareIcon className="w-3.5 lg:w-5" />
        </button>
      </div>
    </nav>
  );
};

export default Header;
